import React from 'react';
import styles from './index.css';
class BackTopBottom extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isShowFixed: false,
            isShowToBottomFixed: true,
        };
        this.pageToTop = () => {
            if (document.documentElement) {
                document.documentElement.scrollTop = document.body.scrollTop = 0;
            }
        };
        this.pageToBottom = () => {
            if (document.documentElement) {
                document.documentElement.scrollTop = document.body.scrollTop = document.body.scrollHeight;
            }
        };
    }
    componentDidMount() {
        this.isShowFixedFn();
    }
    isShowFixedFn() {
        const windowHeight = document.documentElement && document.documentElement.clientHeight;
        const scrollHeight = document.documentElement && (document.documentElement.scrollTop || document.body.scrollTop);
        let isShowBool = false;
        let isShowToBottomBool = false;
        if (windowHeight && scrollHeight) {
            window.addEventListener('scroll', () => {
                setTimeout(() => {
                    const pageHeight = document.body.clientHeight;
                    const twoSreenHeight = windowHeight * 2;
                    const lastScreenHeight = pageHeight - windowHeight * 2;
                    if (scrollHeight >= twoSreenHeight && !isShowBool) {
                        this.setState({
                            isShowFixed: true,
                        });
                        isShowBool = true;
                    }
                    else if (scrollHeight < twoSreenHeight && isShowBool) {
                        this.setState({
                            isShowFixed: false,
                        });
                        isShowBool = false;
                    }
                    if (scrollHeight >= lastScreenHeight && !isShowToBottomBool) {
                        this.setState({
                            isShowToBottomFixed: false,
                        });
                        isShowToBottomBool = true;
                    }
                    else if (scrollHeight < lastScreenHeight && isShowToBottomBool) {
                        this.setState({
                            isShowToBottomFixed: true,
                        });
                        isShowToBottomBool = false;
                    }
                }, 100);
            });
        }
    }
    render() {
        const { isShowFixed, isShowToBottomFixed } = this.state;
        return (isShowFixed && (React.createElement("section", { className: styles.fixIcon },
            React.createElement("a", { href: "javascript:", onClick: this.pageToTop, className: styles.fixTopIcon }),
            isShowToBottomFixed && (React.createElement("a", { href: "javascript:", onClick: this.pageToBottom, className: styles.fixBottomIcon })))));
    }
}
export default BackTopBottom;
